import type { SessionLayoutVersion } from '@heidi/runtime/analytics';

// Split from the hook side so `@/lib/snowplow` can read the layout without
// pulling React into its import graph.
//
// Ordered, though session routes normally mount one layout root: it makes
// overlapping route transitions safe — latest committed root wins, and
// unmounting it restores the previous one.
const activeSessionLayouts = new Map<symbol, SessionLayoutVersion>();

/** Read by the analytics pipeline at event time. */
export function getSessionLayoutVersion(): SessionLayoutVersion | undefined {
  let latest: SessionLayoutVersion | undefined;
  for (const version of activeSessionLayouts.values()) latest = version;
  return latest;
}

/** Delete + set moves an updated owner to the end, keeping "latest wins". */
export function setSessionLayoutVersion(
  owner: symbol,
  version: SessionLayoutVersion | undefined
): void {
  activeSessionLayouts.delete(owner);
  if (version) activeSessionLayouts.set(owner, version);
}

export function __resetSessionLayoutAnalyticsContextForTests(): void {
  activeSessionLayouts.clear();
}
